<template>
	<!-- col -->
	<div class="container-box" :class="{empty}" :style="boxStyle"
	     v-mousedown-outside:[boxIndex]="blockListDropdownClose">

		<div class="plus_icon" v-if="empty" v-mousedown-outside:[boxIndex]="blockListDropdownClose"
		     @mousedown="activeteRow"
		     @click.stop="openBlockList($event, boxIndex)"
		     :class="{active: showBlocksList}" >
          <span class="plus_icon_trigger">
            <svg fill="none" viewBox="0 0 20 20" height="20" width="20" xmlns="http://www.w3.org/2000/svg">
                <path xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" d="M10.0002 19.1667C4.93755 19.1667 0.833496 15.0626 0.833496 10C0.833496 4.93743 4.93755 0.833374 10.0002 0.833374C15.0628 0.833374 19.1668 4.93743 19.1668 10C19.1668 15.0626 15.0628 19.1667 10.0002 19.1667ZM10.0002 17.5C14.1423 17.5 17.5002 14.1422 17.5002 10C17.5002 5.8579 14.1423 2.50004 10.0002 2.50004C5.85803 2.50004 2.50016 5.8579 2.50016 10C2.50016 14.1422 5.85803 17.5 10.0002 17.5ZM10.8335 9.16671H14.1668V10.8334H10.8335V14.1667H9.16683V10.8334H5.8335V9.16671H9.16683V5.83337H10.8335V9.16671Z" fill="#97AACD"></path>
            </svg>
          </span>
		</div>

		<div class="add_block_line" v-if="showBlocksList" v-draw-line></div>

		<Container :data-to-watch="blocks"
				:key="'dnd_'+counter"
				       :get-ghost-parent="getGhostParent"
		           group-name="common"
		           orientation="vertical"
		           @drop="onCommonDrop($event, id, index)"
		           @drag-start="dragStart"
		           drag-class="ghost-dragging"
		           :drop-placeholder="upperDropPlaceholderOptions"
		           non-drag-area-selector=".no-drag,.editor_active,.editable_text"
		           :get-child-payload="getCommonPayload()"
		           :tag="{value: 'div', props: {class: 'common-level'}}">

			<!-- Render draggables even if they are not visible to make sure the right drag index is accounted for. -->
			<BlockWrapper v-for="(childBlock, blockIndex) in blocks" :is-popup="isPopup"
					              :id="childBlock.id" :index="blockIndex" :row="rowId"
					              :containerId="container.id" :box-index="boxIndex"
					              :block="childBlock" :col="col" :key="'BlockWrapper_'+childBlock.id">
            <keep-alive v-if="isVisible(childBlock)">
							<component :is="'block-'+childBlock.type" :is-popup="isPopup"
							           :containerId="container.id" :box-index="boxIndex"
							           :block="childBlock" :id="childBlock.id"  />
            </keep-alive>
					</BlockWrapper>

		</Container>
	</div>
	<!-- col END -->
</template>

<script>
import { mapGetters } from "vuex"
import { Container, Draggable } from 'vue-smooth-dnd'
import { applyDrag } from '@/modules/page-editor/src/utils/helpers'

import BlockWrapper from "@/modules/page-editor/src/components/content/BlockWrapper.vue";

import ElementBlock from "@/modules/page-editor/src/components/sidebar/ElementBlock.vue"

import ColumnsToAddButton from "@/modules/page-editor/src/components/parts/ColumnsToAddButton";

import spacer from "@/modules/page-editor/src/components/content/Spacer.vue";
import button from "@/modules/page-editor/src/components/content/Button.vue";
import headline from "@/modules/page-editor/src/components/content/Headline.vue";
import paragraph from "@/modules/page-editor/src/components/content/Paragraph.vue";
import image from "@/modules/page-editor/src/components/content/Image.vue";
import video from "@/modules/page-editor/src/components/content/Video.vue";
import link from "@/modules/page-editor/src/components/content/Link.vue";
import social from "@/modules/page-editor/src/components/content/Social.vue";
import menu from "@/modules/page-editor/src/components/content/Menu.vue";
import timer from "@/modules/page-editor/src/components/content/Timer.vue";
import custom from "@/modules/page-editor/src/components/content/Custom.vue";
import progressBar from "@/modules/page-editor/src/components/content/ProgressBar.vue";
import formElement from "@/modules/page-editor/src/components/content/FormElement.vue";
import twoStepForm from "@/modules/page-editor/src/components/content/TwoStepForm.vue";
import paymentForm from "@/modules/page-editor/src/components/content/PaymentForm.vue";
import productList from "@/modules/page-editor/src/components/content/ProductList.vue";
import orderSummary from "@/modules/page-editor/src/components/content/OrderSummary.vue";
import orderBump from "@/modules/page-editor/src/components/content/OrderBump.vue";
import WrapperDocking from "@/modules/page-editor/src/components/base/wrapper-docking";
import {
	borderProps, boxShadow, fontProps, getAlignment, getOrientation, getPadding
} from "@/modules/page-editor/src/utils/props";
import imageSlider from "@/modules/page-editor/src/components/content/ImageSlider";
import Faq from "@/modules/page-editor/src/components/content/Faq";
import beforeAfterSlider from "@/modules/page-editor/src/components/content/beforeAfterSlider";

let counter = 0;

export default {
    name: 'container-box',
    props: ['index', 'col', 'box', 'rowId', 'container', 'boxIndex', 'isPopup'],
    components: {
	    blockFaq:Faq,
	    WrapperDocking,
	    blockBeforeAfterSlider:beforeAfterSlider,
        BlockWrapper,
        blockSpacer: spacer,
        blockButton: button,
        blockHeadline: headline,
        blockParagraph: paragraph,
        blockImage: image,
        blockVideo: video,
        blockLink: link,
        blockSocial: social,
        blockMenu: menu,
        blockTimer: timer,
        blockCustom: custom,
        Container, Draggable,
        blockProgressBar: progressBar,
        blockFormElement: formElement,
        blockTwoStepForm: twoStepForm,
        blockPaymentForm: paymentForm,
        blockProductList: productList,
        blockOrderSummary: orderSummary,
		    blockOrderBump: orderBump,
		    blockImageSlider: imageSlider,
	    blockContainer: () => import("@/modules/page-editor/src/components/content/ContainerBlock"),
        ElementBlock,
        ColumnsToAddButton,
    },
    data() {
        return {
	        counter: ++counter,
	        upperDropPlaceholderOptions: {
		        className: 'cards-drop-preview',
		        animationDuration: '50',
		        showOnTop: true
	        },
            addNewRowState: false,

            showBlocksList: false,
            showBlocksListIndex: false,
            boxHovered: false,
            appendState: false,
            prependState: false,
            columnNumbersArray: ['one', 'two', 'three', 'four', 'five', 'six'],
        }
    },
    computed: {
        ...mapGetters(['page_findChildren', 'current_view']),
        content() {
            return this.container;
        },
	    blocks(){
		    return this.page_findChildren(this.box.children, this.isPopup);
	    },
	    empty(){
		    return !this.box.children || !this.box.children.length
	    },
	    boxes(){
		    return this.container.attributes.basic.boxes;
	    },
        basic() {
            return this.content ? this.content.attributes.basic : false
        },
        advanced() {
            return this.content ? this.content.attributes.advanced : false
        },
        getResponsive() {
            var globalView = this.$store.state.page.view;
            var currentView = this.content.responsive;
            if(currentView && !currentView[globalView]) return {display: 'none'}
            else return {display: 'flex'}
        },
	    boxStyle() {
		    let w = `calc(${this.box.width===0?0:(this.box.width||100)}${this.box.type||'%'} - 2px)`
		    if (this.orientation==='row') {
			    if (this.box.width===0) w = `0${this.box.type||'%'}`;
			    if (!this.box.width) w = 'unset';
			    else w = `calc(${this.box.width}${this.box.type||'%'} - 2px)`;
		    }

		    return {
			    width:w,
			    minWidth:w==='unset'?0:w, // must be 0, otherwise it flex-box would grow to fit all children.
			    maxWidth:w
		    }
	    },
	    orientation(){
		    return getOrientation(this.basic.orientation, this.current_view);
	    },
        id() {
            return this.container.id;
        },
        style() {
	        return {
		        backgroundColor: this.basic.backgroundColor || null,
		        backgroundImage: this.bgImage(this.basic.backgroundImage),
		        backgroundPosition: 'center',
		        backgroundSize: 'cover',
		        backgroundRepeat: 'no-repeat',
		        margin: getPadding(this.basic.margin),
		        padding: getPadding(this.basic.padding),
		        ...borderProps(this.basic.border),
		        ...fontProps(this.basic.font),
		        boxShadow: boxShadow(this.basic.shadows),
	        };
        },
    },
    methods: {
	    getGhostParent(){
				return document.querySelector('.page-container.content-root');
	    },
	    isVisible(block){
		    let responsive = block.responsive;
		    return !(responsive && !responsive[this.current_view]);
	    },
	    openBlockList(ev, index){
		    if (this.showBlocksList) {
			    this.showBlocksList = false;
			    this.showBlocksListIndex = false;
					return;
		    }
		    this.$store.commit('PAGE_SET_CURRENT_BLOCK_WRAPPER',
				    {isEmpty:true, index:0, id:this.container.id, row:this.rowId, col:index,
					    containerId: this.container.id, boxIndex: this.boxIndex, isBox: true});

		    this.$store.commit('PAGE_SET_TABID', {tab: 'add', id: this.container.id});

		    this.showBlocksList = true;
		    this.showBlocksListIndex = index;
	    },
	    onCommonDrop(dropResult = false, row, col) {
		    if (dropResult.addedIndex !== null && dropResult.payload
				    && dropResult.payload.element_type && dropResult.payload.structure) {

			    this.$store.dispatch('PAGE_ADD_ELEMENT',
					    {index:dropResult.addedIndex,type,
						    containerId: this.id, isBox: true,toBoxIndex:this.boxIndex,
						    parent: this.id, row, col, element:dropResult.payload});

		    } else if(dropResult && dropResult.addedIndex !== null && dropResult.payload &&
				    dropResult.payload.group === 'common') { //from toolbar
			    var {type} = dropResult.payload
			    this.$store.dispatch('PAGE_ADD_COMMON',
					    { type, row, col, index: dropResult.addedIndex,
						    fromBoxIndex:dropResult.payload.fromBoxIndex, toBoxIndex:this.boxIndex,
						    containerId: this.id, isBox: true});

		    } else if (dropResult.removedIndex !== null && dropResult.addedIndex !== null) { //from siblings
			    this.$store.commit('PAGE_DROP_COMMON', {...dropResult,
				    fromBoxIndex:dropResult.payload.fromBoxIndex, toBoxIndex:this.boxIndex,
				    containerId:this.id, isBox:true});
		    } else if(dropResult.addedIndex !== null) { //from outside
			    var to = row;
			    var colTo = col;
			    var indexTo = dropResult.addedIndex;
			    var from = dropResult.payload.rowFrom;
			    var colFrom = dropResult.payload.colFrom;
			    var indexFrom = dropResult.payload.index;
			    var item = dropResult.payload.item;

			    this.$store.commit('PAGE_DROP_COMMON_ADD',
					    { from, colFrom, indexFrom, to, colTo, indexTo, item,
						    fromBoxIndex:dropResult.payload.fromBoxIndex, toBoxIndex:this.boxIndex,
						    fromContainerId:dropResult.payload.fromContainerId, toContainerId:this.id });

			    to = colTo = indexTo = from = colFrom = indexFrom = item = null;
		    }
		    this.clearDragClass();
		    this.sidabarElementDrop();
	    },
	    sidabarElementDrop(){
		    this.showBlocksList = false;
		    this.showBlocksListIndex = false;
	    },
	    getCommonPayload() {
		    return index => {
			    var item = this.boxes[this.boxIndex].children[index];
			    return {rowFrom:0, colFrom:0, index, item, containerId:this.id,
				    fromContainerId: this.id, fromBoxIndex:this.boxIndex, toBoxIndex:0, isBox:true}
		    }
	    },
	    dragStart(dragResult) {
		    var {isSource, payload} = dragResult;
		    if(isSource) {
			    var target = document.querySelector('.content-root');
			    target.classList.add('common-dragging');
		    }
		    var _this = this;
		    var clearClasses = function() {
			    window.removeEventListener('mouseup', clearClasses)
			    _this.clearDragClass();
		    }
		    window.addEventListener('mouseup', clearClasses);
	    },
	    clearDragClass() {
		    var target = document.querySelector('.content-root');
		    target.classList.remove('section-dragging', 'row-dragging', 'common-dragging');
	    },

	    bgImage(bgImage) {
		    if (!bgImage) return null;

		    let src = bgImage.replace("https://", "")
		    if (src.indexOf("images.funnelish.com")>=0)
			    src = src.replace("images.funnelish.com", "img.funnelish.com");
		    return `url("//${src}?auto=webp&clip=bounds")`;
	    },

        rowClick(event){
            if(event.target.classList.contains('smooth-dnd-container') || event.target.classList.contains('col-inner-blocks') || event.target.classList.contains('row_columns')){
                this.activeteRow();
            }
        },
        appendRow(cols) {
            this.$store.dispatch('PAGE_ADD_ROW', {type: 'row', parent: this.content.parent, index: this.rowIndex +1, cols});
        },
        prependRow(cols) {
            this.$store.dispatch('PAGE_ADD_ROW', {type: 'row', parent: this.content.parent, index: this.rowIndex, cols});
        },
        cloneRow() {
            this.$store.dispatch('PAGE_CLONE_ROW', this.content);
        },

        clickOutRoot(ev) {
            this.prependState = false;
            this.appendState = false;

            this.showBlocksList = false;
            this.showBlocksListIndex = false;
        },
        clickOutEmpty() {
            this.addNewRowState = false;
        },

        colDrag(event, cols, index) {
            if(cols) {
                var _this = this;
                event.target.classList.add('dragging');
                event.target.classList.add('active');
                var parent = event.target.parentElement;
                parent.classList.add('dragging-parent');

                var resize = function(ev) {
                    ev.preventDefault();
                    ev.stopPropagation();
                    var parentWidth = parent.offsetWidth;
                    var totalWidth = parent.parentElement.offsetWidth;
                    var newParentWidth = Math.floor(((ev.pageX - parent.getBoundingClientRect().left)/ totalWidth)*100);
                    var delta = cols[index].value - newParentWidth;
                    var nextWidth = cols[index+1].value + delta;
                    if(newParentWidth % 2 === 0 && newParentWidth >= 5 && nextWidth >= 5) {
                        parent.style.width = newParentWidth + '%';
                        parent.nextSibling.style.width = nextWidth + '%';
                    }
                }

                var stopResize = function(ev) {
                    window.removeEventListener('mousemove', resize);
                    window.removeEventListener('mouseup', stopResize);
                    _this.colDragEnd(event, cols, index);
                }

                window.addEventListener('mousemove', resize);
                window.addEventListener('mouseup', stopResize);
            }
        },
        colDragEnd(event, cols, index) {
            event.target.classList.remove('dragging');
            event.target.classList.remove('active');
            event.target.parentElement.classList.remove('dragging-parent');
            var width = event.target.parentElement.style.width;
            width = Math.floor(width.replace('%', ''));
            this.$store.commit('PAGE_RESIZE_BOX', {containerId: this.container.id, index, width});
            width = null;
        },

        activeteRow(ev) {
            if(!this.container.selected){
                this.$store.commit('PAGE_SET_TABID', {tab: 'basic', id: this.container.id, block:this.container});
            }
        },
        blockListDropdownClose(v) {
            // if(this.showBlocksListIndex === index) {
                this.showBlocksList = false;
                this.showBlocksListIndex = false;
            // }
        },
	    clickOutsideTest(ev) {
		    if (!ev.target.classList.contains('add_block_line')) this.showBlocksList = false;
	    },
    }
}
</script>
<style lang="scss" scoped>
.container-box {
	margin: 0 1px;

	&.empty {
		min-height: 50px;
		.smooth-dnd-container {
			overflow: hidden;
		}
		.plus_icon {
			position: absolute;
			cursor: pointer;
			width: 100%;
			height: 100%;
			.plus_icon_trigger {
				height: 100%;
			}
		}
	}

}
</style>
